@if (urlProperties$ | async; as urlProperties) {
	<stages-dialog2 #dialog>
		<stages-dialog-header />
		<form [formGroup]="urlForm" class="content" novalidate stagesFocusError>
			<h1 translate="{{ titleKey }}"></h1>
			<div class="form" novalidate>
				<div class="form-group">
					<div class="input-container md required">
						<label class="input-label" for="name" translate="files.name"></label>
						<input
							type="text"
							class="text fullsize"
							tabindex="1"
							formControlName="name"
							[stagesMaxLength]="255"
							stagesAutofocus
							stagesValidateOnBlur
						/>
						<div class="info">
							@if (urlName?.dirty || urlName?.touched) {
								<div class="errors">
									@if (urlName?.hasError("required")) {
										<div class="error" role="alert" translate="input.required"></div>
									}
									@if (urlName?.hasError("max")) {
										<div
											class="error"
											role="alert"
											translate="input.maxLength"
											[translateParams]="{ length: 255 }"
										></div>
									}
								</div>
							}
							<div class="maxlength">{{ urlName?.value.length || 0 }}/255</div>
						</div>
					</div>
				</div>
				<div class="form-group">
					<div class="input-container md required">
						<label class="input-label" for="url" translate="files.url"></label>
						<input
							id="url"
							name="url"
							type="text"
							class="text fullsize"
							tabindex="1"
							formControlName="url"
							stagesValidateOnBlur
						/>
						<div class="info">
							<div class="errors">
								@if (url?.dirty || url?.touched) {
									@if (url?.hasError("required")) {
										<div class="error" role="alert" translate="input.required"></div>
									}
									@if (url?.hasError("urlPattern")) {
										<div class="error" role="alert" translate="input.pattern.url"></div>
									}
								}
								@if (!url?.errors || url?.errors?.length === 0) {
									<div class="error" role="alert">&nbsp;</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
		<footer>
			<div class="buttons">
				<button class="button sm cancel" (click)="cancel()" translate="cancel"></button>
				<button class="button sm save" [disabled]="isButtonDisabled(urlForm)" (click)="save(urlProperties)">
					@if (!saveInProgress) {
						<span translate="files.start.url.button"></span>
					}
					@if (saveInProgress) {
						<stages-spin size="s"></stages-spin>
					}
				</button>
			</div>
		</footer>
	</stages-dialog2>
}
